import UserSelector from './UserSelector';

export default UserSelector;
